import { Injectable } from '@angular/core';
import type { ReportTypeFindInterface } from '@zaoblako/shared/modules/personalization/dtos/report-type/report.type.find.dto';
import type { SavedFilterFindInterface } from '@zaoblako/shared/modules/personalization/dtos/saved-filter/saved-filter-find.dto';
import type { SavedFilterFormInterface } from '@zaoblako/shared/modules/personalization/dtos/saved-filter/saved-filter-form.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalizationService extends BaseService {
  protected baseUrl = '/basis/personalization';

  public getReportTypes(): Observable<ReportTypeFindInterface[]> {
    return this.http.get<ReportTypeFindInterface[]>(`${this.baseUrl}/report-types`);
  }

  public getSavedFilter(): Observable<SavedFilterFindInterface[]> {
    return this.http.get<SavedFilterFindInterface[]>(`${this.baseUrl}/saved-filter`);
  }

  public getSavedFilterById(id: number): Observable<SavedFilterFindInterface> {
    return this.http.get<SavedFilterFindInterface>(`${this.baseUrl}/saved-filter/${id}`);
  }

  public addSavedFilter(body: SavedFilterFormInterface): Observable<SavedFilterFindInterface> {
    return this.http.post<SavedFilterFindInterface>(`${this.baseUrl}/saved-filter`, body);
  }

  public setSavedFilter(id: number, body: SavedFilterFormInterface): Observable<SavedFilterFindInterface> {
    return this.http.put<SavedFilterFindInterface>(`${this.baseUrl}/saved-filter/${id}`, body);
  }

  public deleteSavedFilter(id: number): Observable<SavedFilterFindInterface> {
    return this.http.delete<SavedFilterFindInterface>(`${this.baseUrl}/saved-filter/${id}`);
  }

  public favoriteSavedFilter(id: number): Observable<SavedFilterFindInterface> {
    return this.http.post<SavedFilterFindInterface>(`${this.baseUrl}/saved-filter/${id}/favorite`, {});
  }

  public favoriteDeleteSavedFilter(id: number): Observable<SavedFilterFindInterface> {
    return this.http.delete<SavedFilterFindInterface>(`${this.baseUrl}/saved-filter/${id}/favorite`, {});
  }
}
